import React, { useEffect, useState } from 'react';
import Nav from '../../../shared/components/Nav';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { getPAGAA000 } from '../../../services/Api';
import { updateMenuVisibility } from '../../../utils';
const PAGAH010 = () => {
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div id="tableVolunteer">
                <h3 className="vln__tit">덴탈잡 모바일앱</h3>
                <div className="vln-mbl">
                    <div className="vln-mbl__img">
                        <img src="./images/PAGAH010/image-sample.jpg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PAGAH010;
